import { ActivityResult } from "@/abilities/activities/models/activity.model.ts";
import { ActivityEdge } from "@/shared/services/graphql/generated/admin-graph-types.ts";
import { GetDataDisplayPropertiesByConfig } from "@/shared/data-display-config/composable/data-display-config.ts";

export const mapActivityEdgeToActivityResult = (
    activityEdge: ActivityEdge,
    getDataDisplayPropertiesByConfig?: GetDataDisplayPropertiesByConfig
) => {
    const highlightText = (activityEdge.highlights?.text ?? activityEdge.highlights?.title ?? undefined) as
        | string[]
        | undefined;
    const highlightTitle = activityEdge.highlights?.title?.[0] ?? undefined;

    const value: ActivityResult = {
        id: activityEdge.node.id,
        title: activityEdge.node.teasers?.title ?? activityEdge.node.localizations?.title ?? "",
        language: activityEdge.node.language,
        cursor: activityEdge.cursor,
        highlights: { text: highlightText, title: highlightTitle },
        propertyItems: getDataDisplayPropertiesByConfig ? getDataDisplayPropertiesByConfig(activityEdge.node) : [],
    };

    return value;
};
